var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvgTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_4276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7317 12.5482C13.7317 12.548 13.7317 12.5479 13.7316 12.5476C15.1351 11.3516 16 9.71823 16 7.91698C16 4.25054 12.4183 1.27832 8 1.27832C3.58172 1.27832 0 4.25054 0 7.91698C0 11.5834 3.58172 14.5556 8 14.5556C9.47734 14.5556 10.8608 14.2229 12.0485 13.6435C12.0485 13.6435 13.3782 15.2279 16 14.5556C16 14.5556 13.8837 13.6332 13.7317 12.5482Z",
    fill: "#4F95CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.28772 7.91698C1.28772 4.43042 4.52672 1.57188 8.64384 1.29976C8.43144 1.28573 8.21675 1.27832 7.99997 1.27832C3.58169 1.27832 -3.05176e-05 4.25051 -3.05176e-05 7.91698C-3.05176e-05 11.5834 3.58169 14.5556 7.99997 14.5556C8.21681 14.5556 8.43159 14.5483 8.64406 14.5342C4.52681 14.2621 1.28772 11.4036 1.28772 7.91698Z",
    fill: "#4674B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80681 7.40926C8.32965 7.78232 8.321 8.04257 8.321 8.49373C8.321 8.65857 8.23425 8.84942 7.80912 8.84942C7.45343 8.84942 7.33197 8.71929 7.33197 8.26817C7.33197 7.52208 7.66162 7.16636 7.91322 6.94948C8.1995 6.70654 8.68534 6.43761 8.68534 5.96914C8.68534 5.57007 8.33834 5.3792 7.90453 5.3792C7.01962 5.3792 7.21047 6.0472 6.742 6.0472C6.50775 6.0472 6.22147 5.89104 6.22147 5.55267C6.22147 5.0842 6.75934 4.39014 7.93056 4.39014C9.04103 4.39014 9.77844 5.00607 9.77844 5.82161C9.77844 6.63714 9.04106 7.22707 8.80681 7.40926ZM8.48581 10.116C8.48581 10.4717 8.19084 10.784 7.81781 10.784C7.44475 10.784 7.15847 10.4717 7.15847 10.116C7.15847 9.75167 7.45343 9.44804 7.81781 9.44804C8.18218 9.44801 8.48581 9.75167 8.48581 10.116Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_4276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgTime);
export default __webpack_public_path__ + "static/media/avg_time.8019efb533f66e54a88f99064ba9a738.svg";
export { ForwardRef as ReactComponent };